import { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-repository-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { GitlabIcon, GitlabIconBorderless, GitlabSearchResultIcon } from './icon';

export const gitlabConfig: ThirdPartyConfig = {
	displayName: 'Gitlab',
	id: 'gitlab',
	resourceType: ProductResourceTypes3P.Gitlab,
	icon: get3PLogo(GitlabIcon, 'Gitlab', 'medium'),
	iconBorderless: get3PLogo(GitlabIconBorderless, 'Gitlab', 'small'),
	searchResultIcon: get3PLogo(GitlabSearchResultIcon, 'Gitlab', 'large'),
	integrationAri: 'ari:cloud:platform::integration/gitlab',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Repository,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Repository, NounSubtypeKey.Project],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
